/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_CurrencyInputs */

const fr_validation_currency = /** @type {(inputs: Validation_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez un code devise à trois lettres pris en charge.`)
};

const en_validation_currency = /** @type {(inputs: Validation_CurrencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a supported three-letter currency code.`)
};

/**
* | output |
* | --- |
* | "Choose a supported three-letter currency code." |
*
* @param {Validation_CurrencyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_currency = /** @type {((inputs?: Validation_CurrencyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_CurrencyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_currency(inputs)
	return fr_validation_currency(inputs)
});